module.exports = __webpack_public_path__ + "static/img/3904_phase_function_Paper_PointsHejduk_Prediction.bfd6a06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3904_phase_function_Paper_PointsHejduk_Prediction.png
// module id = O5Fo
// module chunks = 0